<template>
<v-layout column>
    <v-flex xs12>
    <v-layout row wrap>
        <v-flex xs12 v-if="!completed">
            <v-layout row wrap>
                <v-flex xs12 pb-3>
                    <h3 class="headline">
                        {{$t('SIGNUP_REGISTRATION_TITLE')}}
                    </h3>
                </v-flex>
                <v-flex xs12>
                    {{$t('SIGNUP_ORGANIZATION_DESCRIPTION')}}
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        :label="requiredTextFieldLabel(organizationName, 'SIGNUP_ORGANIZATION_NAME')"
                        v-model="organizationName"
                        @input="attemptedValidation = false"
                        v-validate="`required|max:${maxFieldLength}`"
                        :error-messages="errors.collect('organization name')"
                        data-vv-name="organization name"
                        :disabled="loading"
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        v-model="name"
                        required
                        v-validate="`required|max:${maxFieldLength}`"
                        :error-messages="errors.collect('name')"
                        @input="attemptedValidation = false"
                        :disabled="loading"
                        data-vv-name="name"
                        :label="requiredTextFieldLabel(name, 'SIGNUP_NAME')"/>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                        v-model="email"
                        required
                        v-validate="`required|email|max:${maxFieldLength}`"
                        :error-messages="errors.collect('email')"
                        @input="attemptedValidation = false"
                        :disabled="loading"
                        data-vv-name="email"
                        :label="requiredTextFieldLabel(email, 'SIGNUP_EMAIL')"/>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-else-if="!loading && completed">
            <v-layout row wrap>
                <v-flex xs12>
                    <h3 class="headline">
                        {{$t('SIGNUP_SUBMISSION_COMPLETED')}}
                    </h3>
                </v-flex>
                <v-flex xs12 v-html="$t('SIGNUP_SUBMISSION_COMPLETED_TEXT')"/>
            </v-layout>
        </v-flex>
    </v-layout>
    </v-flex>
    <v-spacer/>
    <v-flex xs12 v-if="!completed">
        <v-layout row wrap>
            <v-spacer/>
            <v-btn @click="signUp" :loading="loading" color="primary" class="elevation-0" :disabled="loading" :aria-label="$t('SIGNUP_BUTTON_TEXT')">
                {{$t('SIGNUP_BUTTON_TEXT')}}
            </v-btn>
        </v-layout>
    </v-flex>
</v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';
import MessageSubject from "@interfaces/messageSubject";
import Loading from '@utils/Loading.vue';
import { IContentSupportEmail } from '@cyber-range/cyber-range-api-content-client'
import { validateAll } from '@utils/validateAll';
import { useApiClientStore } from "@/stores/apiClientStore";

@Component({ components: { Loading }})
export default class UscrOrganizationSignUp extends Vue {
    get contentApiClient() { return useApiClientStore().contentApiClient; }
    maxFieldLength: number = 128;
    name: string = '';
    email: string = '';
    organizationName: string = '';
    loading: boolean = false;
    completed: boolean = false;

    requiredTextFieldLabel(value: string, stringKey: string){
        return `${this.$t(stringKey)}${(value === '')? '*': ''}`;
    }

    get messageWithOrganizationDetails(): IContentSupportEmail {
        return {
            subject: MessageSubject.ORGANIZATION_SIGNUP,
            body: `Subject ${MessageSubject.ORGANIZATION_SIGNUP}
                    Name: ${this.name}
                    Email: ${this.email}
                    Organization: ${this.organizationName}`
        };
    }

    async signUp(): Promise<void> {
        if(await validateAll(this) && this.$validator.errors.items.length === 0){
            this.$emit('submitting', true);
            try{
                this.loading = true;
                await this.contentApiClient.sendSupportEmail(this.messageWithOrganizationDetails);
                this.completed = true;
            } catch ( e ) {
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
.bottomRight {
    position: absolute;
    bottom: 0;
    right: 0;
}
.progress {
    position: absolute;
    width: 100%;
    bottom: 40%;
}
</style>